import { Station } from '@app/core/types/stations';

export function useYoutubeStatsEnabled(station: Station) {
  return Boolean(station.youtubeChannelId);
}
